import React from 'react';
import { useTranslation } from 'react-i18next';

import { uiHelpers } from '../../helpers';
import { apiv2Url } from '../../services/config';
import { ReactTable } from '../../types';
import DLTable from '../table/DLTable/DLTable';

interface Props {
  stockCode: string;
  strategyResult: unknown[];
}

const StockStrategy: React.FC<Props> = ({ stockCode, strategyResult }) => {
  const { t } = useTranslation();
  const imgUrl = `${apiv2Url}/nopStrategyPng?ticker=` + stockCode;

  const columns: ReactTable.Column[] = [
    {
      Header: t('n_trades'),
      id: 'n_trades',
      accessor: 'n_trades',
      width: 50,
      Cell: ({ cell: { value } }) => <div>{value}</div>,
      disableFilters: true,
    },
    {
      id: 'win_rate',
      Header: t('win_rate'),
      accessor: 'win_rate',
      width: 70,
      Cell: ({ cell: { value } }) => (
        <div>{uiHelpers.formatPercentage(value)}</div>
      ),
      sortDescFirst: true,
      disableFilters: true,
    },
    {
      id: 'mean_annual_return',
      Header: t('mean_annual_return'),
      accessor: 'mean_annual_return',
      width: 70,
      Cell: ({ cell: { value } }) => (
        <div>{uiHelpers.formatPercentage(value)}</div>
      ),
      disableFilters: true,
    },
    {
      id: 'max_drawdown_rate',
      Header: t('max_drawdown_rate'),
      accessor: 'max_drawdown_rate',
      width: 70,
      Cell: ({ cell: { value } }) => (
        <div>{uiHelpers.formatPercentage(value)}</div>
      ),
      disableFilters: true,
    },
    {
      id: 'calmar_ratio',
      Header: t('calmar_ratio'),
      accessor: 'calmar_ratio',
      width: 70,
      Cell: ({ cell: { value } }) => <div>{value.toFixed(2)}</div>,
      disableFilters: true,
    },
    {
      id: 'sharpe_ratio',
      Header: t('sharpe_ratio'),
      accessor: 'sharpe_ratio',
      width: 70,
      Cell: ({ cell: { value } }) => <div>{value.toFixed(2)}</div>,
      disableFilters: true,
    },
    {
      id: 'sharpe_ratio_SH',
      Header: t('sharpe_ratio_SH'),
      accessor: 'sharpe_ratio_SH',
      width: 70,
      Cell: ({ cell: { value } }) => <div>{value.toFixed(2)}</div>,
      disableFilters: true,
    },
    {
      id: 'total_return',
      Header: t('total_return'),
      accessor: 'total_return',
      width: 70,
      Cell: ({ cell: { value } }) => (
        <div>{uiHelpers.formatPercentage(value)}</div>
      ),
      disableFilters: true,
    },
    {
      id: 'total_return_SH',
      Header: t('total_return_SH'),
      accessor: 'total_return_SH',
      width: 70,
      Cell: ({ cell: { value } }) => (
        <div>{uiHelpers.formatPercentage(value)}</div>
      ),
      disableFilters: true,
    },
  ];
  return (
    <div>
      <DLTable
        tableId="stock-strategy"
        columns={columns}
        data={strategyResult || []}
        showAllRows={true}
        defaultSortBy={[
          {
            id: 'sharpe_ratio',
            desc: true,
          },
        ]}
      />
      <img
        src={imgUrl}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </div>
  );
};

export default StockStrategy;
